import styled from "styled-components";

export const NotificationContainer = styled.div`
  width: 100%;
  background-color: var(--main-color);
  border: 1px solid var(--border-color);
  padding: 1rem;
  border-radius: 6px;
  margin-bottom: .7rem;
  font-size: .9rem;
`;
